import { render, staticRenderFns } from "./kaishichuli.vue?vue&type=template&id=2ac07e93&scoped=true&"
import script from "./kaishichuli.vue?vue&type=script&lang=js&"
export * from "./kaishichuli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac07e93",
  null
  
)

export default component.exports